import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: '@lib.core.ErrorBoundaryApp.title',
    defaultMessage: "Grr, There's an Error!",
  },
  message: {
    id: '@lib.core.ErrorBoundaryApp.message',
    defaultMessage: 'Please bear with us and try again later.',
  },
});
